// Clock times that coaches type by hand, e.g. the training plan start time.
// Stored as 24h 'HH:MM' (same as workouts.reservation_start_time) and always
// shown as 'h:mm AM/PM'.

/**
 * Parse what a coach typed into 24h 'HH:MM'.
 * Accepts '6', '630', '6:30', '6:30am', '6:30 AM', '18:30'.
 * Returns '' for blank input and null when the value can't be read as a time.
 */
export function parseTimeOfDay(input) {
  if (input == null) return '';
  const raw = String(input).trim().toUpperCase().replace(/\./g, '');
  if (raw === '') return '';

  const match = raw.match(/^(\d{1,2})(?::?([0-5]\d))?\s*(AM|PM)?$/);
  if (!match) return null;

  let hours = parseInt(match[1], 10);
  const minutes = match[2] ? parseInt(match[2], 10) : 0;
  const meridiem = match[3];

  if (meridiem) {
    if (hours < 1 || hours > 12) return null;
    hours = (hours % 12) + (meridiem === 'PM' ? 12 : 0);
  } else if (hours > 23) {
    return null;
  }

  return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
}

/** Render 24h 'HH:MM' as 'h:mm AM/PM'; '' when there is no time. */
export function formatTimeOfDay(hhmm) {
  if (!hhmm) return '';
  const match = String(hhmm).trim().match(/^([01]?\d|2[0-3]):([0-5]\d)$/);
  if (!match) return '';
  const hours = parseInt(match[1], 10);
  return `${hours % 12 || 12}:${match[2]} ${hours >= 12 ? 'PM' : 'AM'}`;
}
